import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import {ic_search} from 'react-icons-kit/md/ic_search'
import {ic_delete} from 'react-icons-kit/md/ic_delete'
import {ic_print} from 'react-icons-kit/md/ic_print'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrDatePicker from '../components/FrDatePicker'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Vencimentos(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [comboModelo, setComboModelo] = useState([])
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')

 
  const columns = [
    {id: 'codigo', numeric: false, label: 'Código', align: 'left', minWidth: 20},
    {id: 'origem', numeric: false, label: 'Origem', align: 'left', minWidth: 120},
    {id: 'modelo', numeric: false, label: 'Modelo', align: 'left', minWidth: 150},
    {id: 'tipo_doc', numeric: false, label: 'Tipo de Documento', align: 'left', minWidth: 230},
    {id: 'pessoa', numeric: false, label: 'Referente', align: 'left', minWidth: 200},
    {id: 'prazo_ideal', numeric: false, label: 'Prazo Ideal', align: 'left', minWidth: 120},
    {id: 'prazo_limite', numeric: false, label: 'Prazo Limite', align: 'left', minWidth: 120},
    {id: 'prazo_final', numeric: false, label: 'Prazo Final', align: 'left', minWidth: 120},
  ]

  useEffect(() => {
    const fetchData = async () => {
      let tela = 'Vencimentos'
      let consulta = await api.getAcessos(tela, 'Consulta')
      if (consulta !== 'S') {
        return swal.fire('Usuário sem acesso', 'Usuário sem acesso a essa tela!', 'warning')
          .then((result) => {
            if (result.value) {
              window.history.back()
            }
          })
      }
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      // if (query.iframe) require('./styles/iframeReg.css')

      swal.fire({
        html: <FrLoading text="Carregando..."/>,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      if (!props.frame) {
        setenableAdd(await api.getAcessos('Vencimentos', 'Inclusao'))
        setenableEdit(await api.getAcessos('Vencimentos', 'Alteracao'))
        setenableDel(await api.getAcessos('Vencimentos', 'Exclusao'))

        setComboModelo(await api.getComboData('modelo_documento'))

        setFilter(query)
        populateForm(document.getElementById('searchForm'), query)
        if (query.buscar === 'true') {
          let event = new Event('build');
          getData(event)
        }
      }
      swal.close()
    }
    
    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    // if (!isEmpty(queryObject)) {
      if (true){
      queryObject.buscar = true
      setFiltered(true)
      if (!props.frame) {
        window.history.replaceState({ filtered: true }, 'filter', "/ejr/vencimentos?" + objectToQueryString(queryObject));
      }
      swal.fire({
        html: <FrLoading text="Buscando dados..."/>,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/controle', { params: queryObject }).then(r=> {
        console.log(r.data)
        setData(r.data)
        swal.close()
      })
    } else {
      swal.fire('Nenhum filtro informado!', 'Informe ao menos um filtro para realizar a busca.', 'warning')
    }
  }

  function clearForm(e) {
    e.preventDefault();
		console.log('limpa');
    window.history.replaceState({ filtered: false }, 'filter', '/ejr/vencimentos');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    console.log(auxValues)
    auxValues[e.target.name] = e.target.value;
    setFilter(auxValues);
  };

  const print = (e) => {
    e.preventDefault()
    window.print()
  }

  return (
    <div className="Manut">
      {props.frame ? <div/> : <NavBar/>}
      <div className={"ManutContent"+(props.frame ? '-frame' : ' ')}>
        <div className="defaultHeader no-print">
          <h3>Controle de Prazos</h3>
          {props.frame ? <div/> : <UserOptions/>}
        </div>
        <div className="filtersDiv no-print">
          <form id="searchForm" onSubmit={getData}>
          <div>
            <FrTextInput 
              value={filter.origem || ''} 
              style={{width: 230}} 
              name="origem" 
              id="origem" 
              color="#9c9595" 
              label="Origem" 
              variant="outlined" 
              size="small"
              onChange={handleChange} 
            />
            <FrTextInput 
              value={filter.modelo || ''} 
              style={{width: 230}} 
              name="modelo" 
              id="modelo" 
              color="#9c9595" 
              label="Modelo" 
              variant="outlined" 
              size="small"
              onChange={handleChange} 
            />
            <FrTextInput 
              value={filter.referente || ''} 
              style={{width: 230}} 
              name="referente" 
              id="referente" 
              color="#9c9595" 
              label="Referente" 
              variant="outlined" 
              size="small"
              onChange={handleChange} 
            />
            <FrDatePicker
              value={(filter.data_ini || '').split('T')[0] } 
              onChange={handleChange} 
              name="data_ini" 
              id="data_ini" 
              color="#9c9595" 
              label="Prazo Final - Inicial" 
              variant="outlined" 
              size="small"
              style={{width: 190}}
            />
            <FrDatePicker
              value={(filter.data_fim || '').split('T')[0] } 
              onChange={handleChange} 
              name="data_fim" 
              id="data_fim" 
              color="#9c9595" 
              label="Prazo Final - Final" 
              variant="outlined" 
              size="small"
              style={{width: 190}}
            />
            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18}/>
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18}/>
                Limpar
              </button>
              {(enableAdd !== 'S') ? '' :
                <Link to="/ejr/notificacoes/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                  Novo Registro
                </button>
                </Link>}
              <button onClick={print}>
                <Icon icon={ic_print} size={18}/>
                Imprimir
              </button>
            </div>
          </form>
        </div>
        <br/>
        <div className={"tableDiv"+(props.frame && data.length>0 ? '-frame' : '')}>
          <FrTable id='tablediv' regName="vencimentos" frame={props.frame} columns={columns} searched={filtered} codeName="pk_not" page={Vencimentos} data={data} enableEdit={enableEdit} enableDel={enableDel} readOnly/>
        </div>
        {props.frame ? (<div>

        </div>) : <FooterDelphus/>}

      </div>
    </div>
  );
}

export default Vencimentos;
